module.exports = __webpack_public_path__ + "static/media/AWS-color.dcf4eb25.png";